import ComponentStartiOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_common/componentStart.mdx";
import ComponentFormRedirectSubmitiOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_componentWithRedirect/componentSubmit.mdx";
import ComponentErroriOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_common/componentError.mdx";
import ComponentValidationErroriOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_common/componentValidationError.mdx";
import ComponentStepsiOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_componentWithRedirect/componentStep.mdx";
import ComponentUpdateCollectedDataiOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_componentWithRedirect/componentUpdateCollectedData.mdx";
import ComponentCancellableiOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_componentWithRedirect/componentCancelable.mdx";
import ComponentAssociatedTypes from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_componentWithRedirect/componentAssociatedTypes.mdx";
import * as React from 'react';
export default {
  ComponentStartiOS,
  ComponentFormRedirectSubmitiOS,
  ComponentErroriOS,
  ComponentValidationErroriOS,
  ComponentStepsiOS,
  ComponentUpdateCollectedDataiOS,
  ComponentCancellableiOS,
  ComponentAssociatedTypes,
  React
};